<template>

<div id="s02section02" class="slide02-section-block">

  <div class="text-block">

    <Subtitle :text="$t('home.slide02.section02.title')"/>

    <div class="subtitle">
      <Common :text="$t('home.slide02.section02.subtitle')"/>
    </div>

    <SmallCommon :text="$t('home.slide02.section02.text')"/>

  </div>

  <div class="chart-block">
    <Fimage name="slide02section02.png"/>
  </div>

  <Arrow
    type="right"
    toType="carousel"
    :toPos=2
    :toRef=toRef
    :text="$t('home.slide02.section02.arrow')"/>

</div>

</template>

<script>
import Subtitle from '../../general/texts/Subtitle.vue'
import Common from '../../general/texts/Common.vue'
import SmallCommon from '../../general/texts/SmallCommon.vue'
import Fimage from '../../general/elements/Fimage.vue'
import Arrow from '../../general/elements/Arrow.vue'

export default {
  name: 'S02Section02',
  computed: {
    toRef: function() {
      return this.$parent.$parent
    }
  },
  components: {
    Subtitle,
    Common,
    SmallCommon,
    Fimage,
    Arrow
  }
}
</script>

<style lang="scss" scoped>
</style>
